module.exports = __webpack_public_path__ + "static/media/banner3v2.ab791399.png";